import { useCallback, useState } from 'react';
import { readSidebarCollapsed, storeSidebarCollapsed } from '@/lib/sidebarStorage';

export function useSidebarCollapsed(): { isCollapsed: boolean; toggleCollapsed: () => void } {
  const [isCollapsed, setIsCollapsed] = useState(readSidebarCollapsed);

  const toggleCollapsed = useCallback(function toggleCollapsed() {
    setIsCollapsed(function flip(current) {
      const next = !current;
      storeSidebarCollapsed(next);
      return next;
    });
  }, []);

  return { isCollapsed, toggleCollapsed };
}
